import React from "react";
import {
    UserProfileAvatar,
    UserProfileAvatarSizeEnum,
    UserProfileLayoutEnum
} from "../../userProfileAvatar/userProfileAvatar";
import {UserProfileAvatarModel} from "../../userProfileAvatar/userProfileAvatarModel";
import {calculateForloebColumnNumber} from "../forloebOverviewUtils/forloebOverviewUtils";
import {LaegeStillingModel} from "../../../sharedmodels/stilling/laegeStillingModel";
import Tooltip from "core/components/tooltips/Tooltip";
import dayjs from "dayjs";
import {calculatePillColPaddings} from "../OverviewComponent/StyleVariables";
import classNames from "classnames";
import {excludeClickEventIf} from "../../../helpers/classNameHelper";
import {getLaegestillingForloebColor} from "../../../componentsPage/forloeb/forloebHelpers";
import {ForloebKladdeModel} from "../../../sharedmodels/stilling/forloebKladdeModel";
import {Localizer} from "../../../../infrastructure/localization/localizer";
import {GetUddannelsestypeTranslation, UddannelseTypeEnum} from "../../../sharedmodels/stilling/uddannelseTypeEnum";
import useUser from "../../../hooks/useUser";

export interface LaegeStillingViewProps {
    rowIndex: number;
    laegestilling?: LaegeStillingModel;
    forloebKladde?: ForloebKladdeModel
    years: number[];
    handleForloebClicked: (forloebId: string) => void;
    startDate: Date;
    endDate: Date;
    anonymiseret?: boolean;
    excludeClickEvent?: boolean;
    elementId: string;
}

export const LaegeStillingView = ({rowIndex, laegestilling, years, handleForloebClicked, startDate, endDate, anonymiseret = false, elementId, forloebKladde, excludeClickEvent = false}: LaegeStillingViewProps) => {

    const startMonth = startDate.getMonth();
    const startYear = startDate.getFullYear();
    const startColumn = calculateForloebColumnNumber(startMonth, startYear, years);

    const endMonth = endDate.getMonth();
    const endYear = endDate.getFullYear();
    const endColumn = calculateForloebColumnNumber(endMonth, endYear, years, 1);

    const {left, right} = calculatePillColPaddings(dayjs(endDate), dayjs(startDate));

    const style = {
        "--stilling-row-index": rowIndex,
        "--forloeb-column-start": startColumn,
        "--forloeb-column-end": endColumn,
        "--forloeb-column-l-pad": left,
        "--forloeb-column-r-pad": right,
    } as React.CSSProperties;

    const getKladdeText = (forloebKladde: ForloebKladdeModel): string=> {
        return forloebKladde.kommerFraVu
            ? `${forloebKladde.ubesatEfterRundeLukning ? Localizer.forloebpage_planlagtForloebUbesat() : Localizer.forloebpage_planlagtForloeb()} - ${forloebKladde.specialeNavn}${forloebKladde.rundeNavn ? ", " + forloebKladde.rundeNavn : ""}${forloebKladde.delforloebNummer ? ", " + Localizer.forloebpage_hu_forloeb_nr() + forloebKladde.delforloebNummer : ""}`
            : `${Localizer.forloebpage_planlagtForloeb()} - ${forloebKladde.specialeNavn}${forloebKladde.uddannelseType !== UddannelseTypeEnum.KBU ? " - " + GetUddannelsestypeTranslation(forloebKladde.uddannelseType) : ""}`
    }

    return (
        <div
             className={classNames("stilling-laege collapse show", excludeClickEventIf(anonymiseret || excludeClickEvent), forloebKladde && "forloeb-kladde")}
             onClick={() => !anonymiseret && handleForloebClicked(elementId)}
             style={style}>
            <>
                {laegestilling &&
                    <Tooltip className={classNames("laege-stilling-profile text-truncate padding-left-xxs align-self-center", getLaegestillingForloebColor(laegestilling, laegestilling.anonymiseret))}
                             title={laegestilling.ToDataString()}
                             tipClassName='forloeb-or-laege-tooltip-tip'>
                        <UserProfileAvatar size={UserProfileAvatarSizeEnum.extraExstraSmall}
                                           subtle={laegestilling.irrelevant}
                                           userProfileLayoutEnum={UserProfileLayoutEnum.AsTextOnRightSide}
                                           userProfileAvatarModel={UserProfileAvatarModel.BuildFromLaegeStillingModel(laegestilling)}
                        />
                    </Tooltip>
                }
                {forloebKladde &&
                    <Tooltip className={classNames("laege-stilling-profile text-truncate padding-left-xxs align-self-center", forloebKladde.ubesatEfterRundeLukning ? "color-shaded-ubest-forloeb-kladde" :  "color-shaded-forloeb-kladde")}
                             title={forloebKladde.ToDataString()}
                             tipClassName='forloeb-or-laege-tooltip-tip'>
                        <div className={classNames("margin-left-s")}>{getKladdeText(forloebKladde)}</div>
                    </Tooltip>
                }
            </>
        </div>
    );
}
